import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeDunningTypeCreate,
  detail: routeDunningTypeDetail,
  home: routeDunningTypesHome,
  root: routeDunningTypesRoot,
} = createDoctypeRoutes({
  createName: 'new-dunning-type',
  createPath: 'new-dunning-type',
  detailName: 'dunningTypeDetail',
  doctype: DOCTYPES.DUNNING_TYPE,
  homeName: 'dunning-types-home',
  path: 'dunning-type',
  views: {
    create: async () => await import('@/components/viewsExternal/dunningTypes/AddDunningType.vue'),
    detail: async () => await import('@/components/viewsExternal/dunningTypes/ViewDunningType.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export {
  routeDunningTypeCreate,
  routeDunningTypeDetail,
  routeDunningTypesHome,
  routeDunningTypesRoot,
}
